'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var INITIAL_STATE = { selected: '', tabVisible: {} };

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments[1];

  switch (action.type) {
    case 'TAB_SELECTED':
      return _extends({}, state, { selected: action.payload });
    case 'TAB_SHOWED':
      return _extends({}, state, { tabVisible: action.payload });
    default:
      return state;
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/@rafacdb/bah/lib/tabReducer.js
// module id = 114
// module chunks = 0